import { Help, IconSelectFilled } from '@direct-frontend/components';
import { SettingsBlockRowCheckbox } from '#shared/components/SettingsBlockRow';
import { type SettingsIntegrationAIProductTexts } from '../../lib/hooks/useSettingsIntegration.js';

export const AISearchProductTextsSettingsRow = (props: { settings: SettingsIntegrationAIProductTexts }) => {
    const { settings } = props;

    return (
        <SettingsBlockRowCheckbox
            content={null}
            id={`ai-search-product-texts-settings-row-${self.crypto.randomUUID()}`}
            title="Автоматически улучшать заголовки и описания в поиске по товарам с помощью ИИ"
            help={(props) => (
                <Help maxWidth="360" {...props}>
                    ИИ делает тексты более подходящими для объявлений и товарных размещений: выносит важные
                    характеристики товара в начало, делает формулировки понятнее и снижает риск обрезки. Эти тексты
                    создаются отдельно от SEO-метатегов сайта, потому что у рекламы, товарного поиска и SEO разные
                    требования.
                </Help>
            )}
            emptyLabel={settings.value ? 'Включено' : 'Выключено'}
            labelIcon={settings.value ? <IconSelectFilled role="main" color="green" size="12" /> : undefined}
            checkboxValue={Boolean(settings.value)}
            onChange={() => settings.patch(!settings.value)}
        />
    );
};
